<template>
    <div class="content">
        <div class="banner" v-if="banner">
            <img :src="banner"/>
        </div>
        <div class="ctx" v-if="sch">
            <p class="enroll-tip">{{sch && sch.text ? sch.text : text}}</p>
            <div class="enroll-info" v-if="enroll">
                <div class="enroll-item">
                    <div class="enroll-ti">1.您的姓名</div>
                    <div class="enroll-txt">{{enroll.name}}</div>
                </div>
                <div class="enroll-item">
                    <div class="enroll-ti">2.孩子所在年级</div>
                    <div class="enroll-txt">{{enroll.grade}}</div>
                </div>
                <div class="enroll-item">
                    <div class="enroll-ti">3.您的联系方式</div>
                    <div class="enroll-txt">{{enroll.mobile}}</div>
                </div>
                <div class="enroll-item">
                    <div class="enroll-ti">4.关于探校的学校，您最想了解的问题</div>
                    <div class="enroll-txt">{{enroll.question}}</div>
                </div>
            </div>
            <cl-form ref="enrollForm" class="sign-form" :modal="form" :rules="rules" v-else-if="enroll === false">
                <cl-label label="1.您的姓名" prop="name">
                    <cl-input v-model="form.name"></cl-input>
                </cl-label>
                <cl-label label="2.孩子所在年级" prop="grade">
                    <cl-select :options="options" v-model="form.grade"></cl-select>
                </cl-label>
                <cl-label label="3.您的联系方式" prop="mobile">
                    <cl-input v-model="form.mobile"></cl-input>
                </cl-label>
                <cl-label label="4.关于探校的学校，您最想了解的问题是？" prop="question">
                    <cl-input type="textarea" v-model="form.question"></cl-input>
                </cl-label>
                <cl-button type="primary" class="form-sub" @click="sub">提交</cl-button>
            </cl-form>
        </div>
        <p class="mis-tip" v-else>学校信息已更新<br/><a @click="backHome">点击此处</a>返回首页重新报名</p>
    </div>
</template>

<script>
    import {getUserId} from "../common/storage";
    import {overscroll} from "../common/tool";

    export default {
        name: "SchEnroll",
        data() {
            return {
                text: '企鹅探校第一期将去往6所热门高中，想参加的家长请如实填写信息，我们将在开始探校前一天从预约报名的家长中挑选幸运成员一起参与探校哦！',
                banner: null,
                form: {
                },
                options: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一', '初二', '初三', '高一', '高二', '高三'],
                rules: {
                    name: [
                        {require: true, message: '请输入您的姓名'}
                    ],
                    grade:[
                        {require: true, message: '请选择您孩子所在的年级'}
                    ],
                    mobile: [
                        {require: true, message: '请输入您的手机号码'},
                        {regex: '^1[3-9]\\d{9}$', message: '请输入正确的手机号码'}
                    ],
                    question: [
                        {require: true, message: '请填写您最想了解的问题'}
                    ],
                },
                enroll: null
            }
        },
        computed: {
            info() {
                return this.$store.getters.info;
            },
            sch() {
                let result = null;
                let tabs = this.$store.getters.tabs;
                if(tabs) {
                    let index = this.$route.params.index;
                    index = index.split("_");
                    if(index.length > 1) {
                        let tab = tabs[index[0]];
                        if(tab && tab.list) {
                            let sch = tab.list[index[1]];
                            if(sch) {
                                document.title = sch.title;
                                this.checkEnroll(sch.title);
                                result = sch;
                            } else {
                                result = false;
                            }
                        }
                    } else {
                        result = false;
                    }
                }
                return result;
            },
        },
        mounted() {
            overscroll(document.querySelector(".content"));
        },
        methods: {
            checkEnroll(sch) {
                let uid = getUserId(), act = this.info.id;
                this.$axios(`/school-enroll?filter[school]=${sch}&filter[user_id]=${uid}&filter[activity_id]=${act}`).then(res => {
                    let list = res.data;
                    if(list && list.length > 0) {
                        let item = list[0];
                        this.enroll = JSON.parse(item.detail);
                    } else {
                        this.enroll = false;
                    }
                });
            },
            sub() {
                if(this.$refs.enrollForm.validate()) {
                    let form = this.form;
                    let uid = getUserId();
                    this.$axios({
                        url: '/school-enroll',
                        method: 'POST',
                        data: {
                            school: this.sch.title,
                            activity_id: this.info.id,
                            user_id: uid,
                            detail: JSON.stringify(form)
                        }
                    }).then(() => {
                        this.enroll = form;
                        this.$toast('报名成功');
                    });
                }
            },
            backHome() {
                this.$router.replace({name: 'SchHome'})
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../common/less/color";
    .content {
        background-color: @backWhiteColor;
    }
    .enroll-tip {
        padding: 20px 40px 0;
        line-height: 1.5;
        text-align: justify;
        font-size: 26px;
    }
    .mis-tip {
        margin-top: 200px;
        text-align: center;
        line-height: 2;
        a {
            color: @primaryColor;
        }
    }
    .form-sub {
        margin-top: 24px;
    }
    .enroll-info {
        padding: 40px;
    }
    .enroll-item {
        margin-top: 40px;
    }
    .enroll-txt {
        margin-top: 16px;
        font-size: 24px;
        line-height: 1.5;
        color: @tipFontColor;
    }
</style>
